import React from 'react'
import classes from './IndividualFilter.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { setSelectedFilter } from '../../../../../../../redux/globalSlice'
const IndividualFilter = () => {
  const selectedFilter = useSelector((state) => state.global.selectedFilter)
  const dispatch = useDispatch()
  return (
    <div className={classes.box}>
      <div
        onClick={() => {
          dispatch(setSelectedFilter('Summary'))
        }}
        className={`${classes.chip}`}
      >
        Fee Summary
      </div>
      {/* <div
        onClick={() => {
          dispatch(setSelectedFilter('Summary'))
        }}
        className={`${classes.chip} ${selectedFilter === 'Summary' ? classes.activeChip : ''}`}
      >
        Fee Sumary
      </div> */}
      {/* <div
        onClick={() => {
          dispatch(setSelectedFilter('History'))
        }}
        className={`${classes.chip} ${selectedFilter === 'History' ? classes.activeChip : ''}`}
      >
        Student History
      </div> */}
    </div>
  )
}

export default IndividualFilter
